/**
 * 元素是否在 viewport 中
 * @param element
 * @param offset
 * @returns {boolean}
 */
export const isInViewport = (element, offset = 0) => {
  const top = element.offsetTop;
  const height = element.offsetHeight;
  return (
    top - offset < window.pageYOffset + window.innerHeight
    && (top + height) > window.pageYOffset
  );
};

export const isInElementViewport = (element, container, offset = 0) => {
  const top = element.offsetTop;
  const height = element.offsetHeight;
  return (
    top - offset < container.scrollTop + container.offsetHeight
    && (top + height) > container.scrollTop
  );
};
